import React from "react";
import { Button } from 'react-bootstrap';
import { QUOTE_QUESTIONS } from "../AppConstants";
import { IViolationList, IIncidentInfo, IDriver, ViolationSource } from "../classes/Domain";
import IncidentInfo from "../components/IncidentInfo";
import moment from "moment";

interface IState {
    driver: IDriver,
    propsMerged: boolean;
}

interface IProps {
    updatingStore?: boolean,
    violationList: IViolationList,
    driver: IDriver,
    driverIndex: number,
    stateCode?: string,
    errors: any,
    onDriverChange(driver: IDriver, index: number): void;
}

class VialationPart extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.onIncidentChange = this.onIncidentChange.bind(this);
        this.onIncidentDelete = this.onIncidentDelete.bind(this);

        this.state = {
            driver: this.props.driver,
            propsMerged: false
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (prevState.propsMerged) return prevState;
        const driver = nextProps.driver;

        if (driver) {
            const nextState = {
                ...prevState,
                driver: driver,
                propsMerged: true
            };

            return nextState;
        }

        return prevState;
    }

    onAccidentsViolationsChange(value: string) {
        let _driver = { ...this.state.driver, accidentsViolations: value };

        if (value === QUOTE_QUESTIONS.YES_NO.YES) {
            if (!this.state.driver.incidents || this.state.driver.incidents.length === 0) {
                const incendent: IIncidentInfo = {
                    category: "",
                    violation: "",
                    violationCode: "",
                    violationDate: moment(new Date()).toDate(),
                    convictionDate: null,
                    incidentDescription: "",
                    source: ViolationSource.ClientOrSystem
                };

                _driver.incidents = [incendent];
            } else {
                _driver.incidents = [...this.state.driver.incidents];
            }
        }
        else {
            _driver.incidents = [];
        }

        this.setState({ driver: _driver }, () => {
            this.props.onDriverChange(_driver, this.props.driverIndex);
        });
    }

    onIncidentChange(incident: IIncidentInfo, index: number) {
        const incidents = [...(this.state.driver.incidents || [])];
        incidents[index] = incident;
        const _driver = { ...this.state.driver, incidents };

        this.setState({ driver: _driver }, () => {
            this.props.onDriverChange(_driver, this.props.driverIndex);
        });
    }

    onIncidentDelete(index: number) {
        const incidents = [...(this.state.driver.incidents || [])];
        if (index < 0 || index >= incidents.length) {
            return;
        }

        incidents.splice(index, 1);

        const _driver: IDriver = {
            ...this.state.driver,
            incidents,
            // Last incident removed → same as answering No on Violations.
            accidentsViolations: incidents.length === 0
                ? QUOTE_QUESTIONS.YES_NO.NO
                : this.state.driver.accidentsViolations
        };

        this.setState({ driver: _driver }, () => {
            this.props.onDriverChange(_driver, this.props.driverIndex);
        });
    }

    onIncidentAdd() {
        const incendent: IIncidentInfo = {
            category: "",
            violation: "",
            violationCode: "",
            violationDate: new Date(),
            convictionDate: null,
            incidentDescription: "",
            source: ViolationSource.ClientOrSystem
        };

        const _driver = {
            ...this.state.driver,
            incidents: [...(this.state.driver.incidents || []), incendent]
        };

        this.setState({ driver: _driver }, () => {
            this.props.onDriverChange(_driver, this.props.driverIndex);
        });
    }

    render() {
        const incidents = this.state.driver?.incidents || [];
        return (
            <div>
                {
                    incidents.map((incident, index) => (
                        <IncidentInfo
                            key={`incident-${this.props.driverIndex}-${index}`}
                            updatingStore={this.props.updatingStore}
                            incident={incident}
                            violations={this.props.violationList}
                            stateCode={this.props.stateCode}
                            index={index}
                            onChange={this.onIncidentChange}
                            onDelete={this.onIncidentDelete}
                            errors={this.props.errors}
                        />
                    ))
                }

                <div className="btnContainer">
                    <Button
                        className="btnAddViolation"
                        onClick={() => { this.onIncidentAdd() }}
                        disabled={this.props.updatingStore}> <i className="fas fa-plus"></i> Add incident
                    </Button>
                </div>
            </div>
        );
    }
}

export default VialationPart